import { createAction, props } from '@ngrx/store';

import { NewsViewModel } from '../@models/news.model';

const ID = '[News] ';

export const requestNews = createAction(
  `${ID} Request `,
  props<{ newsCount: number }>()
);
export const newsReceived = createAction(
  `${ID} Received`,
  props<{ items: NewsViewModel[] }>()
);
export const newsReceiveFailed = createAction(
  `${ID} Receive failed`,
  props<{ err: any }>()
);

export const increaseNewsViewsCounter = createAction(
  `${ID} Increase news views counter`
);
export const counterIncreased = createAction(`${ID} Counter increased`);
export const counterIncreaseFailed = createAction(
  `${ID}Counter increase failed`,
  props<{ err: any }>()
);
